(function(){
    'use strict'

    angular.module('app.centrosCosto')
    .factory('CentrosCostoService', CentrosCostoService);

    CentrosCostoService.$inject = ['$http', '$q', 'apiSettings', 'UserInfoService'];

    function CentrosCostoService($http, $q, apiSettings, UserInfoService) {

        var api = {
            getAll: getAll,
            getById: getById,
            save: save,
            update:update,
            remove: remove
        };

        return api;

        function getAll(companiaId){

            var url = apiSettings.apiBaseUrl + 'api/centros-costo/' + companiaId;
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getById(companiaId, centroCostoId){

            var url = apiSettings.apiBaseUrl + 'api/centros-costo/' + companiaId + '/' + centroCostoId;
            
            return $http.get(url)
            .then(getByIdSuccess, getByIdError);

            function getByIdSuccess(response){
                return response.data;
            };

            function getByIdError(error) {
                return $q.reject(error);
            }
        };

        function save(centroCosto){

            centroCosto.id = 0;
            centroCosto.companiaId = UserInfoService.getCompaniaId();

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/centros-costo',  
                method: 'POST',  
                data: centroCosto
            });  
            return response;
        };

        function update(centroCosto){

            centroCosto.companiaId = UserInfoService.getCompaniaId();

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/centros-costo',  
                method: 'PUT',  
                data: centroCosto
            });  
            return response;
        };

        function remove(centroCosto){

            centroCosto.companiaId = UserInfoService.getCompaniaId();
            
            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/centros-costo',  
                method: 'DELETE', 
                headers: { 
                    'Content-Type': 'application/json' },
                data: centroCosto
            });  
            return response;
        };

    };

})();